"use strict";

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EventQueue = /*#__PURE__*/function () {
  function EventQueue() {
    _classCallCheck(this, EventQueue);

    this.pullQueue = [];
    this.pushQueue = [];
    this.eventHandlers = {};
    this.isPaused = false;
    this.isStopped = false;
  }

  _createClass(EventQueue, [{
    key: "push",
    value: function push(value) {
      if (this.isStopped) return;
      var resolution = {
        value: value,
        done: false
      };

      if (this.pullQueue.length) {
        var placeholder = this.pullQueue.shift();
        if (placeholder) placeholder.resolve(resolution);
      } else {
        this.pushQueue.push(Promise.resolve(resolution));

        if (this.highWaterMark !== undefined && this.pushQueue.length >= this.highWaterMark && !this.isPaused) {
          this.isPaused = true;

          if (this.eventHandlers.highWater) {
            this.eventHandlers.highWater();
          } else if (console) {
            console.warn("EventIterator queue reached ".concat(this.pushQueue.length, " items"));
          }
        }
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.isStopped) return;
      this.isStopped = true;
      this.remove();

      var _iterator = _createForOfIteratorHelper(this.pullQueue),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var placeholder = _step.value;
          placeholder.resolve({
            value: undefined,
            done: true
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.pullQueue.length = 0;
    }
  }, {
    key: "fail",
    value: function fail(error) {
      if (this.isStopped) return;
      this.isStopped = true;
      this.remove();

      if (this.pullQueue.length) {
        var _iterator2 = _createForOfIteratorHelper(this.pullQueue),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var placeholder = _step2.value;
            placeholder.reject(error);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        this.pullQueue.length = 0;
      } else {
        var rejection = Promise.reject(error);
        /* Attach error handler to avoid leaking an unhandled promise rejection. */

        rejection.catch(function () {});
        this.pushQueue.push(rejection);
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      var _this = this;

      Promise.resolve().then(function () {
        if (_this.removeCallback) _this.removeCallback();
      });
    }
  }, {
    key: Symbol.asyncIterator,
    value: function value() {
      var _this2 = this;

      return {
        next: function next(value) {
          var result = _this2.pushQueue.shift();

          if (result) {
            if (_this2.lowWaterMark !== undefined && _this2.pushQueue.length <= _this2.lowWaterMark && _this2.isPaused) {
              _this2.isPaused = false;

              if (_this2.eventHandlers.lowWater) {
                _this2.eventHandlers.lowWater();
              }
            }

            return result;
          } else if (_this2.isStopped) {
            return Promise.resolve({
              value: undefined,
              done: true
            });
          } else {
            return new Promise(function (resolve, reject) {
              _this2.pullQueue.push({
                resolve: resolve,
                reject: reject
              });
            });
          }
        },
        return: function _return() {
          _this2.isStopped = true;
          _this2.pushQueue.length = 0;

          _this2.remove();

          return Promise.resolve({
            value: undefined,
            done: true
          });
        }
      };
    }
  }]);

  return EventQueue;
}();

var EventIterator = function EventIterator(listen) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$highWaterMark = _ref.highWaterMark,
      highWaterMark = _ref$highWaterMark === void 0 ? 100 : _ref$highWaterMark,
      _ref$lowWaterMark = _ref.lowWaterMark,
      lowWaterMark = _ref$lowWaterMark === void 0 ? 1 : _ref$lowWaterMark;

  _classCallCheck(this, EventIterator);

  var queue = new EventQueue();
  queue.highWaterMark = highWaterMark;
  queue.lowWaterMark = lowWaterMark;

  queue.removeCallback = listen({
    push: function push(value) {
      return queue.push(value);
    },
    stop: function stop() {
      return queue.stop();
    },
    fail: function fail(error) {
      return queue.fail(error);
    },
    on: function on(event, fn) {
      queue.eventHandlers[event] = fn;
    }
  }) || function () {};

  this[Symbol.asyncIterator] = function () {
    return queue[Symbol.asyncIterator]();
  };

  Object.freeze(this);
};

exports.EventIterator = EventIterator;
exports.default = EventIterator;